export const validateForm = (formData) => {
  const { userName, email, mobileNo } = formData;
  let errors = {};
  let isValid = true;

  // Username
  if (!userName?.trim()) {
    errors.userName = "Name is required";
    isValid = false;
  } else if (userName.trim().length < 2) {
    errors.userName = "Name must be at least 2 characters";
    isValid = false;
  }

  // Email
  if (!email?.trim()) {
    errors.email = "Email is required";
    isValid = false;
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }
  }

  // Mobile (optional)
  if (mobileNo && !/^[6-9]\d{9}$/.test(mobileNo)) {
    errors.mobileNo = "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
    isValid = false;
  }

  return { isValid, errors };
};
